
import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';

Swiper.use([Navigation, Pagination, EffectFade]);
export function SetYouTube() {

  // 動画セット
  let player01, player02, player03, player04, player05;
  let playerArray = [];
  let readyPlayer01 = false;
  let readyPlayer02 = false;
  let readyPlayer03 = false;
  let readyPlayer04 = false;
  let readyPlayer05 = false;

  // 背景動画用
  let ytPlayer;
  let ytReady = false;

  function youtubeLoad(index) {
    const onPlayerReady = (event) => {
      event.target.playVideo();
    }

    if (index == 0 && !readyPlayer01) {
      player01 = new YT.Player('page-player01', {
        height: '315', width: '560', videoId: 'QaC-K60WjrA',
        events: {
          'onReady': onPlayerReady,
        }
      });
      readyPlayer01 = true;
      playerArray.push(player01);
    } else if( index == 1 && !readyPlayer02){
      player02 = new YT.Player('page-player02', {
        height: '315', width: '560', videoId: 'HWkXlHQo1JI',
        events: {
          'onReady': onPlayerReady,
        }
      });
      readyPlayer02 = true;
      playerArray.push(player02);
    } else if( index == 2 && !readyPlayer03){
      player03 = new YT.Player('page-player03', {
        height: '315', width: '560', videoId: 'TUgMKMO_ETk',
        events: {
          'onReady': onPlayerReady,
        }
      });
      readyPlayer03 = true;
      playerArray.push(player03);
    } else if( index == 3 && !readyPlayer04){
      player04 = new YT.Player('page-player04', {
        height: '315', width: '560', videoId: 't_lkrzQd6_o',
        events: {
          'onReady': onPlayerReady,
        }
      });
      readyPlayer04 = true;
      playerArray.push(player04);
    } else if( index == 4 && !readyPlayer05){
      player05 = new YT.Player('page-player05', {
        height: '315', width: '560', videoId: '9qNlBXRuQc4',
        events: {
          'onReady': onPlayerReady,
        }
      });
      readyPlayer05 = true;
      playerArray.push(player05);
    }
  }

  let windowTop = 0;
  function modalSwiper() {
    const body = document.querySelector('body');
    const closeBtn = document.querySelectorAll('[data-page-close]'); //閉じるボタン
    const closeArea = document.querySelector('[data-page-closearea]'); //モーダル背景
    const slideBtn = document.querySelectorAll('[data-page-slide]'); //スライド切替ボタン
    const modalAction = document.querySelectorAll('[data-page-modalaction]'); //モーダル表示時にクラスを追加

    //モーダル表示
    const modalOpen = () => {
      modalAction.forEach((item) => {
        item.classList.add("page-modal-active");
      });
      windowTop = window.scrollY;
      body.style.top = - windowTop + "px";
      body.classList.add("page-modal-active"); //bodyの位置をずらすことで、見た目上は、コンテンツの位置を変えない
    }

    //モーダル非表示
    const modalClose = (id) => {
      modalAction.forEach((item) => {
        item.classList.remove("page-modal-active");
      });
      body.classList.remove("page-modal-active"); //fixedを解除
      body.style.top = "";
      window.scrollTo({
        top: windowTop, //元の位置にスクロール
      });
      playerArray.forEach((item) => {
        item.pauseVideo();
      });
    }

    //ボタン クリック
    slideBtn.forEach((item) => {
      item.addEventListener('click', () => {
        modalOpen();
      });
    });
    closeBtn.forEach((item) => {
      item.addEventListener('click', () => {
        modalClose();
      });
    });
    window.addEventListener('click', (e) => {
      if (e.target == closeArea) {
        modalClose();
      }
    });

    //スワイパー
    const pageSwiper = new Swiper("[data-page-modalswiper]", {
      speed: 300, effect: 'fade', autoHeight: true,
      // loop: true,
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: "[data-page-modalnext]", prevEl: "[data-page-modalprev]",
      },
      pagination: {
        el: "[data-page-modalpagination]", clickable: true,
      },
    });

    slideBtn.forEach((item,i) => {
      item.addEventListener('click', () => {
        pageSwiper.slideTo(i, 0);
      });
    });

    pageSwiper.on('slideChange', () => {
      playerArray.forEach((item) => {
        item.pauseVideo();
      });
    });
    pageSwiper.on('slideChangeTransitionEnd', () => {
      youtubeLoad(pageSwiper.activeIndex);
    });
  }
  let isYoutubeReady = false;
  function onYouTubeIframeAPIReady() {

    // 動画モーダル用
    const readyBtn = document.querySelectorAll('[data-page-movieready]');
    readyBtn.forEach((item,i) => {
      item.addEventListener('click', () => {
        if(!isYoutubeReady){
          youtubeLoad(i);
          modalSwiper();
          isYoutubeReady = true;
        }
      });
    });

    // 背景動画用の設定
    ytPlayer = new YT.Player('js-youtube', {//動画を表示させたいIDを指定
      videoId: '-M8nGbgauFc',//動画のアドレスの指定
        playerVars: {
            playsinline: 1,// インライン再生を行う
            autoplay:1,//自動再生を行う
            fs:0,//全画面表示ボタンを表示しない
            rel: 0,// 再生中の動画と同じチャンネルの関連動画を表示
            controls: 0,// プレーヤー コントロールを表示しない
            modestbranding: 1, // YouTubeロゴの非表示
            iv_load_policy: 3, // アノテーションの非表示
            start:0,//50秒後から動画がスタート
        },
        events: {//　イベント
            'onReady': onPlayerBgReady,
            'onStateChange': onPlayerStateChange
        }
    });
  }


  //ミュートにしてから再生する設定
  function onPlayerBgReady(event) {
    event.target.mute();
    event.target.playVideo();
    ytReady = true;
  }
  //ループ設定
  function onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.ENDED) {
      event.target.playVideo();
    }
  }
  function ytCheck() {
    if(ytReady) {
      ytPlayer.playVideo();
    } else {
      setTimeout(ytCheck, 200);
    }
  }
  ytCheck();

  window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

  // 動画エリア表示
  window.addEventListener('load', () => {
    document.querySelector('.movie-area__inner').classList.add('is-show');
  })
}
